'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import IndustrySelectController from "./controller/industrySelect";
import IndustryModalCreateController from "./controller/industryModalCreate";
import IndustriesController from "./controller/industries";
import IndustryTableDirective from "./directive/industryTable";
import IndustryService from "./service/industry";

export default angular.module('investmentProject.industry', [])
    .controller('IndustriesController', IndustriesController)
    .controller('IndustrySelectController', IndustrySelectController)
    .controller('IndustryModalCreateController', IndustryModalCreateController)
    .directive('industryTable', IndustryTableDirective)
    .factory('IndustryService', IndustryService)
    .name;
